import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, useLocation, useNavigate } from "react-router-dom";
import { getToken, returnLoginStatus } from "../hooks/authFunc";
import { userActions } from "../../store/slices/userSlice";
import { mainActions } from "../../store/slices/mainSlice";

const RouterComponent = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const isShowStartPage = useSelector((state) => state.main.isShowStartPage);

  const getData = () => {
    const params = {};
    dispatch(userActions.fetchUserLookup({ params, accessToken }));
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(pathname);
    if (pathname == "/" && isShowStartPage == false) {
      navigate("/home");
    }
    if (returnLoginStatus()) getData();
  }, [pathname]);

  return <Routes>{children}</Routes>;
};

export default RouterComponent;
